import { useMemo } from 'react'

import { Maybe } from 'aem-libs-ts/src/types/utility'

import { describedById } from '../common/tip'
import { CommonInputProps } from './types'


interface DefaultFieldProps {
  ['aria-describedby']?: string
  ['aria-invalid']?: boolean
}

export const useFieldMeta = (
  id: Maybe<string>,
  inputProps: Pick<CommonInputProps, 'tip'> & { unit?: string },
  defaultProps: DefaultFieldProps
) => {
  return useMemo(() => {
    const ariaDescribedByValue = [
      inputProps.unit ? `${id}-unit` : null,
      defaultProps['aria-describedby'],
      inputProps?.tip?.text ? describedById(id) : null
    ]
      .filter(Boolean)
      .join(' ')

    return ariaDescribedByValue?.length > 0
      ? { ...defaultProps, ['aria-describedby']: ariaDescribedByValue }
      : defaultProps
  }, [id, inputProps, defaultProps])
}
